import React, { Component, Fragment } from "react";
import api from "../../../../services/api";
import SelectMeta from "../SelectMeta";
import { Link } from "react-router-dom";

export default class FormMeta extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            aplicationName: "Form Meta",
            cursos: this.props.cursos,
            cursoSelecionado: this.props.cursoSelecionado,
            fonte: ""
        }

    }

    componentDidUpdate(prevProps) {
        if(prevProps.cursoSelecionado !== this.props.cursoSelecionado) {
            if(this.props.cursoSelecionado.fonte !== "SIGEM") {
                this.setState({ fonte: "CRM" })
            }
            else {
                this.setState({ fonte: this.props.cursoSelecionado.fonte })
            }
        }
    }

    onSubmit = async (event) => {
        event.preventDefault();
        try {

            let { codigo, unidade, modalidadee: modalidade, tipo, turno, curso, cargaHoraria, CR, fonte, comentario, tipoMatricula } = event.target;
            let cadastro = {
                codigo: codigo.value,
                unidade: unidade.value,
                modalidade: modalidade.value,
                tipo: tipo.value,
                // turno: turno.value,
                curso: curso.value,
                cargaHoraria: cargaHoraria.value,
                CR: CR.value,
                fonte: fonte.value,
                comentario: comentario.value,
                tipoMatricula: tipoMatricula.value
            }

            let status = await api.post("/metas", cadastro)
            if(status.data.status === "ok") window.showNotification('Cadastrado com sucesso', 'success');
            else window.showNotification(status.data.status || 'Erro ao cadastrar', 'danger');
            await this.props.recarregaDados();

        } catch (erro) {
            alert("Erro ao cadastrar", erro);
        }
    }

    render() {
        return (
            <Fragment>
                <div className="row">
                        <div className="col-md-8 ml-auto mr-auto">
                            <div className="card card-user">
                                <div className="card-header">
                                    <h5 className="card-title">Selecionar Curso</h5>
                                    <Link to={location => (
                                        { 
                                            ...location, 
                                            pathname: `/novocurso`, 
                                            anterior: window.location.pathname || "/unidade", 
                                            unidade: this.props.unidade 
                                        }
                                        )}>
                                        <button className="btn" style={{float: "right"}}>Novo Curso</button>
                                    </Link>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={this.onSubmit} className="gap">

                                        <SelectMeta 
                                            selectModalidade={this.props.selectModalidade} 
                                            label={<label htmlFor="modalidade">Modalidade:</label>}
                                        />

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="cursoList">Curso:</label>
                                                    <select name="cursoList" onChange={this.props.onChange} className="form-control" required>
                                                        <option hidden>Escolha um curso</option>
                                                        {this.props.cursos.map((curso, key) => {
                                                            return (
                                                                <option value={`${curso.codigo}-${curso.curso}`} key={`${curso.codigo}-${curso._id}`}>{`${curso.curso}`} </option>
                                                                )
                                                            })}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-4">
                                                <label htmlFor="pago">Tipo</label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <div className="form-check form-check-inline form-control">
                                                        <input className="form-check-input" type="radio" name="tipo" id="pago" value="Pago" required/>
                                                        <label className="form-check-label" htmlFor="pago">Pago</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <div className="form-check form-check-inline form-control">
                                                        <input className="form-check-input" type="radio" name="tipo" id="gratuidade-regimental" value="Gratuidade Regimental" required/>
                                                        <label className="form-check-label" htmlFor="gratuidade-regimental">Gratuidade Regimental</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <div className="form-check form-check-inline form-control">
                                                        <input className="form-check-input" type="radio" name="tipo" id="nao-regimental" value="Gratuidade Não-Regimental"required/>
                                                        <label className="form-check-label" htmlFor="nao-regimental">Não Regimental</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <div className="row">
                                            <div className="col-4">
                                                <label htmlFor="turno">Turno</label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <div className="form-check form-check-inline form-control">
                                                        <input className="form-check-input" type="radio" name="turno" id="manhã" value="Manhã" required/>
                                                        <label className="form-check-label" htmlFor="manhã">Manhã</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <div className="form-check form-check-inline form-control">
                                                        <input className="form-check-input" type="radio" name="turno" id="tarde" value="Tarde" required/>
                                                        <label className="form-check-label" htmlFor="tarde">Tarde</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <div className="form-check form-check-inline form-control">
                                                        <input className="form-check-input" type="radio" name="turno" id="noite" value="Noite"required/>
                                                        <label className="form-check-label" htmlFor="noite">Noite</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}

                                        <div className="row">
                                            <div className="col-4">
                                                <label htmlFor="tipoMatricula">Tipo de Matrícula:</label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <div className="form-check form-check-inline form-control">
                                                        <input className="form-check-input" type="radio" name="tipoMatricula" id="novas" value="Nova" required/>
                                                        <label className="form-check-label" htmlFor="novas">Matrículas Novas</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <div className="form-check form-check-inline form-control">
                                                        <input className="form-check-input" type="radio" name="tipoMatricula" id="residuais" value="Residual" required/>
                                                        <label className="form-check-label" htmlFor="residuais">Matrículas Residuais</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="curso">Curso</label>
                                                    <input type="text" className="form-control" placeholder="Curso" id="curso" name="curso" defaultValue={this.props.cursoSelecionado.curso} disabled/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="codigo">Código</label>
                                                    <input type="text" className="form-control" placeholder="Código" id="codigo" name="codigo" defaultValue={this.props.cursoSelecionado.codigo} disabled/>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="cargaHoraria">Carga Horária</label>
                                                    <input type="number" className="form-control" placeholder="Carga Horária" id="cargaHoraria" name="cargaHoraria" defaultValue={this.props.cursoSelecionado.cargaHoraria} disabled />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="CR">CR</label>
                                                    <input type="text" className="form-control" placeholder="CR" id="CR" name="CR" defaultValue={this.props.cursoSelecionado["CR"]} disabled />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="fonte">Fonte</label>
                                                    <input type="text" className="form-control" placeholder="Fonte" id="fonte" name="fonte" defaultValue={this.state.fonte} disabled />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 pr-1">
                                                <div className="form-group">
                                                    <label>Modalidade</label>
                                                    <input type="text" className="form-control" placeholder="Modalidade" id="modalidadee" name="modalidadee" defaultValue={this.props.cursoSelecionado.modalidade} disabled/>
                                                </div>
                                            </div>
                                            <div className="col-md-6 pl-1">
                                                <div className="form-group">
                                                    <label htmlFor="unidade">Unidade</label>
                                                    <input type="text" className="form-control" placeholder="Unidade" id="unidade" name="unidade" defaultValue={this.props.cursoSelecionado.unidade} disabled />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Informações adicionais</label>
                                                    <textarea className="form-control textarea" name="comentario" placeholder={"Escreva algo..."}></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="update ml-auto mr-auto">
                                                <button type="submit" className="btn btn-primary btn-round">Cadastrar</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
            </Fragment>
        )
    }


}